import React, { useState } from 'react';
import './mobfilter.css';

import { RiSortDesc } from 'react-icons/ri';
import { AiOutlineClose } from 'react-icons/ai';
// import "jquery-ui-dist/jquery-ui";
import Form from 'react-bootstrap/Form';

import { BiFilterAlt } from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';

const MobSort = (props) => {

    const [sort, setSort] = useState(false);

    const handelClick = (e) => {
        const id = e.target.id;
        props.setSearch({ ...props.search, sort: id})
        setSort(false)
    }

    return (



        <>
 {/* <button class="css-11bcsxn" data-bs-toggle="modal" data-bs-target="#exampleModal2">sort</button>
<div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel2">Sort By</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        

        <select name="sort" class="sort form-select" id="sort-by-productpage-mobile" onchange="filters.setFilter(this.value)">
          <option value=""> sort by</option>
          <option value="alphabetic">Name (A - Z)</option>
          <option value="priceLowToHigh">Price (Low &gt; High)</option>
          <option value="priceHighToLow">Price (High &gt; Low)</option>
          <option value="topRated">Rating (Highest)</option>
          <option value="lowRated">Rating (Lowest)</option>
          <option value="latest">Latest</option>
          <option value="relevance">Relevance</option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <span class="btn btn-primary" onclick="search.search()">Apply</span>
      </div>
    </div>
  </div>
</div> */}
            
            <div className='sort-popup'>

                <div className='sort' onClick={() => setSort(!sort)}>
                    <span> <RiSortDesc /> Sort</span>
                </div>
                {
                    sort ?
                    <div className="short-popup-bg">
                        <div className='popupshow shadow'>
                            <div className="sort-prf">
                                <span className='sort'><RiSortDesc /> Sort</span>
                                <AiIcons.AiOutlineClose onClick={() => setSort(!sort)} />
                            </div>
                            <hr />
                            <ul>
                                <li onClick={handelClick} id='namea' className='sort1'>Name (A - Z)
                                    <Form.Check type="radio"  aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='named' className='sort1'>Name (Z - A)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='pricea' className='sort1'>Budget (Low {">"} High)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='priced' className='sort1'>Budget (High {">"} Low)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='ratinga' className='sort2'>Rating (Low {">"} High)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='ratingd' className='sort2'>Rating (High {">"} Low)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='latest' className='sort3'>Latest
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li onClick={handelClick} id='oldest' className='sort4'>Oldest
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                            </ul>


                        </div>
                        </div> : null
                }



            </div>
            
        </>


    )
}

export default MobSort